'use client';

import { useRouter, useParams } from 'next/navigation'
import { GiDisc } from "react-icons/gi";
import { IoMdHappy } from "react-icons/io";

// import Link from "next/link";
import global from "../globals.css"

// DOM properties must be in camelCase.
export default function Page() {

    const router = useRouter();
    const { id } = useParams();

    return (
        <section className="grid grid-cols-1 box-border border-2 rounded-xl border-solid m-2 ">
            <div className="flex flex-row space-x-2 border-none m-2">
                <div className="flex flex-auto items-center justify-center bg-gray-100 p-4">
                    <div className="w-full max-w-md rounded-xl bg-white p-8 shadow-lg">
                        <h4 className="block text-xl font-medium text-slate-800">
                            Sign Up
                        </h4>
                        <h5 className="text-slate-500 font-light">
                            Hello <IoMdHappy /> Enter your details to register.  <GiDisc />
                        </h5>
                        <form className="mt-8 mb-2 w-80 max-w-screen-lg sm:w-96">
                            <div className="mb-1 flex flex-col gap-6">
                                <div className="w-full max-w-sm min-w-[200px]">
                                    <label className="block mb-2 text-sm text-slate-600">
                                    First Name
                                    </label>
                                    <input type="text" className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow" placeholder="First Name" />
                                </div>
                                <div className="w-full max-w-sm min-w-[200px]">
                                    <label className="block mb-2 text-sm text-slate-600">
                                    Surname
                                    </label>
                                    <input type="text" className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow" placeholder="Surname" />
                                </div>
                                <div className="w-full max-w-sm min-w-[200px]">
                                    <label className="block mb-2 text-sm text-slate-600">
                                    Email
                                    </label>
                                    <input type="email" className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow" placeholder="your@email.com" />
                                </div>
                                <div className="w-full max-w-sm min-w-[200px]">
                                    <label className="block mb-2 text-sm text-slate-600">
                                    Username
                                    </label>
                                    <input type="email" className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow" placeholder="Username" />
                                </div>
                                <div className="w-full max-w-sm min-w-[200px]">
                                    <label className="block mb-2 text-sm text-slate-600">
                                    Password
                                    </label>
                                    <input type="password" className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow" placeholder="Password" />
                                </div>
                                <div className="w-full max-w-sm min-w-[200px]">
                                    <label className="block mb-2 text-sm text-slate-600">
                                    Confirm Password
                                    </label>
                                    <input type="password" className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow" placeholder="Confirm Password" />
                                </div>
                                
                                <div className="w-full max-w-sm min-w-[200px]">
                                <button className="mt-4 w-full rounded-md bg-slate-800 py-2 px-4 border border-transparent text-center text-sm text-white transition-all shadow-md hover:shadow-lg focus:bg-slate-700 focus:shadow-none active:bg-slate-700 hover:bg-slate-700 active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none" type="button">
                                Sign Up 
                                </button>
                                <p className="flex justify-center mt-6 text-sm text-slate-600">
                                Already have account?
                                <a href="#" className="ml-1 text-sm font-semibold text-slate-700 underline">
                                    Sign-In 
                                </a>
                                </p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section> 
    );
}